import {FormsySchema, PayoutSchemaKeys} from '.';
import {SWIFT_CODE_REGEX} from '../../../shared/constants/regex';

const getPayoutSchema = (getMessage, messages): FormsySchema<PayoutSchemaKeys> => ({
    gatewayType: {
        identifier: 'gatewayType',
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            )
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.payoutInfo.accountType')
        },
        optionLabel: {
            payPal: getMessage(messages, 'label.affiliate.form.payoutInfo.accountType.paypal'),
            bank: getMessage(messages, 'label.affiliate.form.payoutInfo.accountType.bank')
        }
    },
    foreignBank: {
        identifier: 'foreignBank',
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            )
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.payoutInfo.usBank')
        },
        optionLabel: {
            yes: getMessage(messages, 'label.affiliate.form.payoutInfo.foreignBank.yes'),
            no: getMessage(messages, 'label.affiliate.form.payoutInfo.foreignBank.no')
        }
    },
    payPal: {
        identifier: 'accountEmail',
        validations: {
            isEmail: true
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            isEmail: getMessage(messages, 'errors.com.epicgames.validation.invalid', ['email'])
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.payoutInfo.paypal')
        }
    },
    checkName: {
        identifier: 'checkName',
        validations: {
            maxLength: 64,
            validEnglishOnlyField: true
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [64]),
            validEnglishOnlyField: getMessage(
                messages,
                'errors.com.epicgames.validation.must.english',
                [getMessage(messages, 'label.affiliate.form.payoutInfo.checkName')]
            )
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.payoutInfo.checkName')
        }
    },
    bankName: {
        identifier: 'bankName',
        require: true,
        validations: {
            maxLength: 128,
            validEnglishOnlyField: true
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [128]),
            validEnglishOnlyField: getMessage(
                messages,
                'errors.com.epicgames.validation.must.english',
                [getMessage(messages, 'label.affiliate.form.payoutInfo.bankName')]
            )
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.payoutInfo.bankName')
        }
    },
    routingNo: {
        identifier: 'routingNo',
        validations: {
            maxLength: 32,
            isNumeric: true,
            validRoutingNumber: true
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32]),
            isNumeric: getMessage(messages, 'errors.com.epicgames.validation.must.number'),
            validRoutingNumber: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                'routing number'
            ])
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.payoutInfo.RoutingNum'),
            toolTip: getMessage(messages, 'ui.profile.bank.form.popover')
        }
    },
    bankAccountNo: {
        identifier: 'bankAccountNo',
        validations: {
            maxLength: 42,
            isValidBandAccountNo: true
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [42]),
            isValidBandAccountNo: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                'Bank Account number'
            ])
        },
        display: {
            textBankAccountNo: getMessage(
                messages,
                'label.affiliate.form.payoutInfo.text_bankAccountNo'
            ),
            textIBAN: getMessage(messages, 'label.affiliate.form.payoutInfo.text_IBAN')
        }
    },
    swiftCode: {
        identifier: 'swiftCode',
        validations: {
            maxLength: 32,
            matchRegexp: SWIFT_CODE_REGEX
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32]),
            matchRegexp: getMessage(messages, 'errors.com.epicgames.validation.invalid', [
                'swift code'
            ])
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.payoutInfo.swiftCode')
        }
    },
    accountDetails: {
        identifier: 'additionalAccountDetail',
        validations: {
            maxLength: 1024
        },
        validationMessages: {
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [1024])
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.payoutInfo.accountDetails')
        }
    }
});

export default getPayoutSchema;
